import React from "react";
import TenantsContainer from "@commr/admin/components/tenants/tenantsContainer";

const TenantsPage: React.FC<React.PropsWithChildren<unknown>> = () => (
  <TenantsContainer />
);

export default TenantsPage;
